import * as React from "react";
function StatusSuccessIcon(props) {
    return React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", height: "1em", width: "1em", ...props },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m4.707-9.918-1.414-1.414L6.75 9.21 4.707 7.168 3.293 8.582 6.75 12.04z", clipRule: "evenodd" }));
}
export default StatusSuccessIcon;
//# sourceMappingURL=StatusSuccess.js.map